import { useCallback, useState } from 'react'
import { useMounted } from '../../../Hooks/useMounted'
import { UserSchema } from '../../../Schema/UserSchema'
import { useAppDispatch } from '../../../Hooks/useAppDispatch'
import { UsersActions } from '../StoreAdapter'
import { ServiceLocator } from '../../../Services/ServiceLocator'
import { UsersAPI } from '../../../Services/API/UsersAPI'

export const useAddUser = () => {
  const dispatch = useAppDispatch()
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const addUser = useCallback(
    async (schema: UserSchema): Promise<UserSchema> => {
      setProcessing(true)
      return ServiceLocator.resolve(UsersAPI)
        .createEntity(schema)
        .then((schema) => {
          dispatch(UsersActions.addOne(schema))
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(null)
          }
          return schema
        })
        .catch((err) => {
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(err.message)
            throw err
          }
          return null
        })
    },
    [dispatch, mounted],
  )

  return {
    processing,
    error,
    errorMessage,
    addUser,
  }
}
